import {
  Companion_getInstance3azjmcnlvtkjq as Companion_getInstance,
  OauthClientf2xy0pwltr7q as OauthClient,
} from './models.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ServerFile1t91jzpzoixwe as ServerFile } from '../../files/ServerFile.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareOauthClientFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [OauthClient__id_getInstance(), OauthClient_niceName_getInstance(), OauthClient_logo_getInstance(), OauthClient_scopes_getInstance(), OauthClient_secrets_getInstance(), OauthClient_redirectUris_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function OauthClient__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function OauthClient__id$_get_name_$ref_b71y0m() {
  return (p0) => p0.i20();
}
function OauthClient__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OauthClient__id$_get_serializer_$ref_lb0cvl() {
  return (p0) => p0.h2j();
}
function OauthClient__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function OauthClient__id$_get_annotations_$ref_xq4e1h() {
  return (p0) => p0.bz();
}
var OauthClient__idClass;
function OauthClient__id() {
  if (OauthClient__idClass === VOID) {
    class $ {
      constructor() {
        OauthClient__id_instance = this;
        var tmp = this;
        tmp.p2m_1 = lazy(OauthClient__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q2m_1 = lazy(OauthClient__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r2m_1 = lazy(OauthClient__id$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.p2m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OauthClient__id$_get_name_$ref_b71y0m(), null);
        return tmp0.f2();
      }
      s2m(receiver) {
        return receiver.t2m_1;
      }
      k2j(receiver) {
        return this.s2m(receiver instanceof OauthClient() ? receiver : THROW_CCE());
      }
      z2m(receiver, value) {
        return receiver.a2n(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof OauthClient() ? receiver : THROW_CCE();
        return this.z2m(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.q2m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OauthClient__id$_get_serializer_$ref_lb0cvl(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r2m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OauthClient__id$_get_annotations_$ref_xq4e1h(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'OauthClient__id', VOID, VOID, [SerializableProperty()]);
    OauthClient__idClass = $;
  }
  return OauthClient__idClass;
}
var OauthClient__id_instance;
function OauthClient__id_getInstance() {
  if (OauthClient__id_instance === VOID)
    new (OauthClient__id())();
  return OauthClient__id_instance;
}
function OauthClient_niceName$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function OauthClient_niceName$_get_name_$ref_8rl5yq() {
  return (p0) => p0.i20();
}
function OauthClient_niceName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OauthClient_niceName$_get_serializer_$ref_cslgrd() {
  return (p0) => p0.h2j();
}
function OauthClient_niceName$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function OauthClient_niceName$_get_annotations_$ref_dghtrx() {
  return (p0) => p0.bz();
}
var OauthClient_niceNameClass;
function OauthClient_niceName() {
  if (OauthClient_niceNameClass === VOID) {
    class $ {
      constructor() {
        OauthClient_niceName_instance = this;
        var tmp = this;
        tmp.b2n_1 = lazy(OauthClient_niceName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c2n_1 = lazy(OauthClient_niceName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d2n_1 = lazy(OauthClient_niceName$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.b2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OauthClient_niceName$_get_name_$ref_8rl5yq(), null);
        return tmp0.f2();
      }
      s2m(receiver) {
        return receiver.u2m_1;
      }
      k2j(receiver) {
        return this.s2m(receiver instanceof OauthClient() ? receiver : THROW_CCE());
      }
      z2m(receiver, value) {
        return receiver.a2n(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof OauthClient() ? receiver : THROW_CCE();
        return this.z2m(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.c2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OauthClient_niceName$_get_serializer_$ref_cslgrd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OauthClient_niceName$_get_annotations_$ref_dghtrx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'OauthClient_niceName', VOID, VOID, [SerializableProperty()]);
    OauthClient_niceNameClass = $;
  }
  return OauthClient_niceNameClass;
}
var OauthClient_niceName_instance;
function OauthClient_niceName_getInstance() {
  if (OauthClient_niceName_instance === VOID)
    new (OauthClient_niceName())();
  return OauthClient_niceName_instance;
}
function OauthClient_logo$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function OauthClient_logo$_get_name_$ref_9njvxx() {
  return (p0) => p0.i20();
}
function OauthClient_logo$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OauthClient_logo$_get_serializer_$ref_c2m7tw() {
  return (p0) => p0.h2j();
}
function OauthClient_logo$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function OauthClient_logo$_get_annotations_$ref_2zvecg() {
  return (p0) => p0.bz();
}
var OauthClient_logoClass;
function OauthClient_logo() {
  if (OauthClient_logoClass === VOID) {
    class $ {
      constructor() {
        OauthClient_logo_instance = this;
        var tmp = this;
        tmp.e2n_1 = lazy(OauthClient_logo$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f2n_1 = lazy(OauthClient_logo$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g2n_1 = lazy(OauthClient_logo$annotations$delegate$lambda);
        this.h2n_1 = null;
        this.i2n_1 = 'null';
      }
      i20() {
        var tmp0 = this.e2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OauthClient_logo$_get_name_$ref_9njvxx(), null);
        return tmp0.f2();
      }
      j2n(receiver) {
        return receiver.v2m_1;
      }
      k2j(receiver) {
        var tmp = this.j2n(receiver instanceof OauthClient() ? receiver : THROW_CCE());
        return tmp == null ? null : new (ServerFile())(tmp);
      }
      k2n(receiver, value) {
        return receiver.a2n(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof OauthClient() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof ServerFile()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.l2n_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.k2n(tmp, tmp_0);
      }
      h2j() {
        var tmp0 = this.f2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OauthClient_logo$_get_serializer_$ref_c2m7tw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OauthClient_logo$_get_annotations_$ref_2zvecg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'OauthClient_logo', VOID, VOID, [SerializableProperty()]);
    OauthClient_logoClass = $;
  }
  return OauthClient_logoClass;
}
var OauthClient_logo_instance;
function OauthClient_logo_getInstance() {
  if (OauthClient_logo_instance === VOID)
    new (OauthClient_logo())();
  return OauthClient_logo_instance;
}
function OauthClient_scopes$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function OauthClient_scopes$_get_name_$ref_ascyi1() {
  return (p0) => p0.i20();
}
function OauthClient_scopes$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OauthClient_scopes$_get_serializer_$ref_yy4icw() {
  return (p0) => p0.h2j();
}
function OauthClient_scopes$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function OauthClient_scopes$_get_annotations_$ref_1thwyc() {
  return (p0) => p0.bz();
}
var OauthClient_scopesClass;
function OauthClient_scopes() {
  if (OauthClient_scopesClass === VOID) {
    class $ {
      constructor() {
        OauthClient_scopes_instance = this;
        var tmp = this;
        tmp.m2n_1 = lazy(OauthClient_scopes$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n2n_1 = lazy(OauthClient_scopes$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o2n_1 = lazy(OauthClient_scopes$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'kotlin.collections.setOf' call
        tmp_2.p2n_1 = emptySet();
        this.q2n_1 = 'setOf()';
      }
      i20() {
        var tmp0 = this.m2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OauthClient_scopes$_get_name_$ref_ascyi1(), null);
        return tmp0.f2();
      }
      s2m(receiver) {
        return receiver.w2m_1;
      }
      k2j(receiver) {
        return this.s2m(receiver instanceof OauthClient() ? receiver : THROW_CCE());
      }
      r2n(receiver, value) {
        return receiver.a2n(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof OauthClient() ? receiver : THROW_CCE();
        return this.r2n(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OauthClient_scopes$_get_serializer_$ref_yy4icw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OauthClient_scopes$_get_annotations_$ref_1thwyc(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'OauthClient_scopes', VOID, VOID, [SerializableProperty()]);
    OauthClient_scopesClass = $;
  }
  return OauthClient_scopesClass;
}
var OauthClient_scopes_instance;
function OauthClient_scopes_getInstance() {
  if (OauthClient_scopes_instance === VOID)
    new (OauthClient_scopes())();
  return OauthClient_scopes_instance;
}
function OauthClient_secrets$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function OauthClient_secrets$_get_name_$ref_2t5qgj() {
  return (p0) => p0.i20();
}
function OauthClient_secrets$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OauthClient_secrets$_get_serializer_$ref_19hxwm() {
  return (p0) => p0.h2j();
}
function OauthClient_secrets$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function OauthClient_secrets$_get_annotations_$ref_n2r4ke() {
  return (p0) => p0.bz();
}
var OauthClient_secretsClass;
function OauthClient_secrets() {
  if (OauthClient_secretsClass === VOID) {
    class $ {
      constructor() {
        OauthClient_secrets_instance = this;
        var tmp = this;
        tmp.s2n_1 = lazy(OauthClient_secrets$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t2n_1 = lazy(OauthClient_secrets$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u2n_1 = lazy(OauthClient_secrets$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'kotlin.collections.setOf' call
        tmp_2.v2n_1 = emptySet();
        this.w2n_1 = 'setOf()';
      }
      i20() {
        var tmp0 = this.s2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OauthClient_secrets$_get_name_$ref_2t5qgj(), null);
        return tmp0.f2();
      }
      s2m(receiver) {
        return receiver.x2m_1;
      }
      k2j(receiver) {
        return this.s2m(receiver instanceof OauthClient() ? receiver : THROW_CCE());
      }
      x2n(receiver, value) {
        return receiver.a2n(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof OauthClient() ? receiver : THROW_CCE();
        return this.x2n(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.t2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OauthClient_secrets$_get_serializer_$ref_19hxwm(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OauthClient_secrets$_get_annotations_$ref_n2r4ke(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'OauthClient_secrets', VOID, VOID, [SerializableProperty()]);
    OauthClient_secretsClass = $;
  }
  return OauthClient_secretsClass;
}
var OauthClient_secrets_instance;
function OauthClient_secrets_getInstance() {
  if (OauthClient_secrets_instance === VOID)
    new (OauthClient_secrets())();
  return OauthClient_secrets_instance;
}
function OauthClient_redirectUris$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function OauthClient_redirectUris$_get_name_$ref_rzts25() {
  return (p0) => p0.i20();
}
function OauthClient_redirectUris$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OauthClient_redirectUris$_get_serializer_$ref_fmaegk() {
  return (p0) => p0.h2j();
}
function OauthClient_redirectUris$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function OauthClient_redirectUris$_get_annotations_$ref_32v4y0() {
  return (p0) => p0.bz();
}
var OauthClient_redirectUrisClass;
function OauthClient_redirectUris() {
  if (OauthClient_redirectUrisClass === VOID) {
    class $ {
      constructor() {
        OauthClient_redirectUris_instance = this;
        var tmp = this;
        tmp.y2n_1 = lazy(OauthClient_redirectUris$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z2n_1 = lazy(OauthClient_redirectUris$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a2o_1 = lazy(OauthClient_redirectUris$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'kotlin.collections.setOf' call
        tmp_2.b2o_1 = emptySet();
        this.c2o_1 = 'setOf()';
      }
      i20() {
        var tmp0 = this.y2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OauthClient_redirectUris$_get_name_$ref_rzts25(), null);
        return tmp0.f2();
      }
      s2m(receiver) {
        return receiver.y2m_1;
      }
      k2j(receiver) {
        return this.s2m(receiver instanceof OauthClient() ? receiver : THROW_CCE());
      }
      r2n(receiver, value) {
        return receiver.a2n(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof OauthClient() ? receiver : THROW_CCE();
        return this.r2n(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.z2n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OauthClient_redirectUris$_get_serializer_$ref_fmaegk(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a2o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OauthClient_redirectUris$_get_annotations_$ref_32v4y0(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'OauthClient_redirectUris', VOID, VOID, [SerializableProperty()]);
    OauthClient_redirectUrisClass = $;
  }
  return OauthClient_redirectUrisClass;
}
var OauthClient_redirectUris_instance;
function OauthClient_redirectUris_getInstance() {
  if (OauthClient_redirectUris_instance === VOID)
    new (OauthClient_redirectUris())();
  return OauthClient_redirectUris_instance;
}
//region block: exports
export {
  prepareOauthClientFields as prepareOauthClientFields2f6ht6w7u5ryt,
};
//endregion

//# sourceMappingURL=OauthClientFields.mjs.map
